<template>
    <div>
        <CCard class="w-100">
            <CCardHeader>
                <h2>Invoice Uang Muka</h2>
            </CCardHeader>
            <CCardBody>                
                <div class="col-xs-6 text-light pb-2">
                    <button id="add" class="btn btn-success"                   
                        @click="addClick()">
                        <i class="fa fa-plus"></i> Add
                    </button>
                </div>
                
                <invoice-down-payment-grid ref="grid" :key="gridReload" :editClick="editClick" :deleteClick="deleteClick" :invoiceDownPaymentClick="invoiceDownPaymentClick"/>
                <down-payment-print-form ref="downPaymentPrintForm"/>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import InvoiceDownPaymentGrid from './Grid/InvoiceDownPaymentGrid.vue';
import invoiceDownPaymentService from './Script/InvoiceDownPaymentScript';
import { sweet_alert } from '../../../infrastructure/constant/variable';
import { response } from '../../../infrastructure/constant/response';
import DownPaymentPrintForm from './Component/DownPaymentPrintForm.vue';

export default {
    name: 'InvoiceDownPayment',
    components: {
        'invoice-down-payment-grid': InvoiceDownPaymentGrid,
        'down-payment-print-form' : DownPaymentPrintForm,
    },
    async mounted () {
        var permission = this.$globalfunc.permissionModule('Invoice Uang Muka');
        document.getElementById("add").disabled = permission.cperms ? false : true;
    },
    data(){
        return{
            gridReload: 0,
            statusButton: '',
        }
    },
    methods: {
        addClick(){
            this.$router.push({ name: 'Invoice Uang Muka Form', params: {  formtype:'Add', id:' ', view:'new' } });
        },
        editClick(id, view){
            const routeData = this.$router.resolve({ name: 'Invoice Uang Muka Form', params: { formtype:'Edit', id:id, view:view } });
            window.open(routeData.href, '_blank');
        },
        async deleteClick(id){
            var data = await invoiceDownPaymentService.getInvoiceDownPaymentQuery(id);
            
            this.$swal(sweet_alert.delete).then((result) => {
                if (result.isConfirmed == true) {
                    this.$loading(true);

                    const piData = {
                        CustomerID : data.customer_id,
                        TaxPercentage : data.tax_percentage,
                        TaxAmount : data.tax_amount,
                        GrandTotal : data.total,
                        Notes : data.notes,
                        Status : "Cancel",
                        Confirmation : true
                    }

                    const variables = {
                        id : id,
                        data : piData
                    } 

                    invoiceDownPaymentService.editQuery(variables).then(res => {
                        this.$loading(false);
                        this.reload();
                        this.$swal("Info", response.successDelete, "success");                 
                    }).catch(error => {
                        this.$loading(false);
                        var errorMessage = globalfunc.errorExtractor(error)
                        this.$swal("Error", errorMessage, "error");
                    })
                }
            });
        },  
        invoiceDownPaymentClick(id, eventId, downPaymentNumber, downPaymentDate) {
            this.$refs.downPaymentPrintForm.addClick(id, eventId, downPaymentNumber, downPaymentDate);
        },
        reload(){
            this.gridReload++;
        },
    }
}
</script>